import { PATH_NAME_ERROR } from '@/common/resources/router.const'

export default [
  {
    path: '*',
    name: PATH_NAME_ERROR,
    components: {
      notfound: () =>
        import(/* webpackChunkName: "notfound" */ '@/pages/error'),
    },
  },
]
